import {SupplyChain} from "@core/api";

export default {
    methods: {
        downloadDocument(id, name, type, ) {
            return new Promise((resolve, reject) => {
                SupplyChain
                    .downloadDocument(type, id)
                    .then(response => {
                        this.__makeDownloadLinkAndClick(name, response.data);

                        resolve();
                    })
                    .catch(reject);
            });
        },

        __makeDownloadLinkAndClick(name, data) {
            const fileURL = window.URL.createObjectURL(new Blob([data]));
            const fileLink = window.document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', name);
            window.document.body.appendChild(fileLink);

            fileLink.click();
        }
    }
};
